import { Box } from '@mui/material'

const DropdownLoadingMessage = () => {
  return <Box textAlign={'center'}>Loading list, please wait.</Box>
}

export default DropdownLoadingMessage
